var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { size } from 'polished';
import { alignItems, borderRadius, boxShadow, display, fontSize, height, lineHeight, maxWidth, minWidth, position, space, width, themeGet, } from 'styled-system';
import { themeRight, themeTop } from '../../common/theme/system-utilities';
import { Button } from '../../common/components/Button';
import Input from '../../common/components/Input';
import Icon from '../../common/components/Icon';
import { useLocalization } from '../../common/providers/LocaleProvider';
import { getSubscribeToNewsletterMutation, } from '../../common/gql/mutation/newsletter';
import { executeQuery } from '../../common/gql';
import { toGQLLocale } from '../../common/gql/utils';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
var FieldState;
(function (FieldState) {
    FieldState[FieldState["Default"] = 0] = "Default";
    FieldState[FieldState["Success"] = 1] = "Success";
    FieldState[FieldState["Error"] = 2] = "Error";
    FieldState[FieldState["Loading"] = 3] = "Loading";
    FieldState[FieldState["Active"] = 4] = "Active";
})(FieldState || (FieldState = {}));
var EMAIL_ICON_SIZE = 24;
var INPUT_ICON_SIZE = 32;
var getColor = function (state, isActive) {
    switch (state) {
        case FieldState.Error:
            return 'colors.red.60';
        case FieldState.Success:
            return 'colors.green.60';
        case FieldState.Loading:
            return 'colors.gray.9';
        default:
            return isActive ? 'colors.gray.9' : 'colors.gray.5';
    }
};
var MessageLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"])), space, display, fontSize, lineHeight, function (_a) {
    var state = _a.state;
    return themeGet(getColor(state));
});
MessageLabel.defaultProps = {
    mt: 'sp_4',
    fontSize: 'fs_14',
    lineHeight: 'lh_20',
};
var EmailInputContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, alignItems, width);
EmailInputContainer.defaultProps = {
    display: 'flex',
    width: '100%',
    alignItems: ['center', null, 'normal'],
};
var EmailInputLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), height, width, maxWidth, position);
EmailInputLabel.defaultProps = {
    position: 'relative',
    maxWidth: '383px',
    height: '40px',
    width: 1,
};
var InputIcon = styled(Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), size(INPUT_ICON_SIZE), position, themeTop, themeRight);
InputIcon.defaultProps = {
    position: 'absolute',
    themeTop: 'sp_4',
    themeRight: 0,
};
var EmailInput = styled(Input)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-right: none;\n  border-color: ", ";\n  ", "\n  ", ";\n\n  &:active,\n  &:focus {\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n\n  ", "\n"], ["\n  border-right: none;\n  border-color: ", ";\n  ", "\n  ",
    ";\n\n  &:active,\n  &:focus {\n    border-color: ",
    ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n\n  ",
    "\n"])), function (_a) {
    var state = _a.state, props = __rest(_a, ["state"]);
    return themeGet(getColor(state))(props);
}, function (_a) {
    var isHome24 = _a.theme.isHome24;
    return !isHome24 && 'border-radius: 0;';
}, function (_a) {
    var state = _a.state;
    return [FieldState.Error, FieldState.Success].includes(state) &&
        'padding-right: 32px;';
}, function (_a) {
    var state = _a.state, props = __rest(_a, ["state"]);
    return themeGet(getColor(state, true))(props);
}, themeGet('colors.gray.15'), function (_a) {
    var state = _a.state, props = __rest(_a, ["state"]);
    var hasMessage = [FieldState.Error, FieldState.Success].includes(state);
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", "\n      ", "\n    "], ["\n      ", "\n      ", "\n    "])), props.theme.isHome24 ? '' : 'border-radius: 0;', hasMessage && 'padding-right: 32px;');
});
EmailInput.defaultProps = __assign(__assign({}, Input.defaultProps), { borderRadius: '3px 0 0 3px', color: 'gray.9', px: 'sp_8' });
var SubmitButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  outline: none;\n  white-space: nowrap;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  outline: none;\n  white-space: nowrap;\n"])), minWidth, space, borderRadius, boxShadow);
SubmitButton.defaultProps = __assign(__assign({}, Button.defaultProps), { boxShadow: 'none', borderRadius: '0 3px 3px 0', minWidth: ['72px', '128px'], p: 'sp_8' });
var SubmitButtonText = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, fontSize);
SubmitButtonText.defaultProps = {
    display: ['none', 'block'],
    fontSize: 'fs_16',
};
var SubscribeIcon = styled(Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), size(EMAIL_ICON_SIZE), display);
SubscribeIcon.defaultProps = {
    display: ['block', 'none'],
};
export var EmailField = function (_a) {
    var tracking = _a.tracking;
    var _b = useLocalization(), locale = _b.locale, t = _b.t;
    var _c = __read(useState(''), 2), inputValue = _c[0], setInputValue = _c[1];
    var _d = __read(useState(false), 2), isValid = _d[0], setFieldValid = _d[1];
    var _e = __read(useState(FieldState.Default), 2), state = _e[0], setState = _e[1];
    var trackingData = {
        event: 'newsLetterSignUpClick',
        eventAction: 'click',
        eventCategory: 'newsletter',
        eventData: {
            products: [
                __assign({ name: 'StandardInLine' }, tracking),
            ],
        },
    };
    var onChangeInput = useCallback(function (event) {
        setFieldValid(event.target.validity.valid);
        setInputValue(event.target.value);
    }, []);
    var onSubmitButtonClick = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, hasError, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isValid) {
                        return [2 /*return*/];
                    }
                    dispatchTrackingEvent(trackingData);
                    setState(FieldState.Loading);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, executeQuery(getSubscribeToNewsletterMutation(inputValue, toGQLLocale(locale)))];
                case 2:
                    response = _a.sent();
                    hasError = response.subscribeToNewsletter.error;
                    setState(hasError ? FieldState.Error : FieldState.Success);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setState(FieldState.Error);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [inputValue, isValid, tracking]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EmailInputContainer, null,
            React.createElement(EmailInputLabel, { "data-testid": "email-input-label", htmlFor: "email-input" },
                React.createElement(EmailInput, { required: true, value: inputValue, hasError: FieldState.Error === state, type: "email", name: "email", id: "email-input", "data-testid": "email-input", "aria-label": t('h24_newsletter_input_placeholder'), placeholder: t('h24_newsletter_input_placeholder'), onChange: onChangeInput, state: state }),
                state === FieldState.Success && React.createElement(InputIcon, { name: "success" }),
                state === FieldState.Error && React.createElement(InputIcon, { name: "error" })),
            React.createElement(SubmitButton, { "data-testid": "submit-button", "aria-labelledby": "submit-button-label", isLoading: FieldState.Loading === state, onClick: onSubmitButtonClick },
                React.createElement(SubscribeIcon, { name: "subscribe" }),
                React.createElement(SubmitButtonText, { id: "submit-button-label" }, t('h24_newsletter_submit_button')))),
        [FieldState.Success, FieldState.Error].includes(state) && (React.createElement(MessageLabel, { state: state, "data-testid": "input-message-label", htmlFor: "email-input" }, FieldState.Error === state
            ? t('h24_newsletter_subscription_error')
            : t('h24_newsletter_subscription_success')))));
};
export default EmailField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
